export default {
	common: {
		noMore: '没有更多了',
		noEmpty: '必传',
		copySuccess: '复制成功',
		copyFail: '复制失败',
		search: '搜索',
		remark: '备注',
		commit: '提交',
		status: '状态',
		revoke: '撤销',
		cancel: '取消',
		confirm: '确认',
	},
	footer: {
		companyValue: '常德市晨星网络科技有限公司',
		addressValue: '湖南省长沙市开福区新湖南大厦事业楼12层',
		icpValue: '湘ICP备2024077971号-1',
		mapValuelat: '28.207508',
		mapValuelan: '112.985372',
		telValue: '0731-85151461',
		jobValue: '李女士',
		jobEmailValue: `lijiahui{'@'}7pa.com`,
		contactValue: '刘蔚',
		emailValue: `liuwei{'@'}7pa.com`
	}
}